import React from 'react';
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  useTheme,
} from '@mui/material';
import {
  School,
  People as PeopleIcon,
  Groups,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const People = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const sections = [
    {
      title: "Faculty",
      description: "Meet our distinguished faculty members who are experts in their respective fields and dedicated to providing quality education.",
      icon: <School sx={{ fontSize: 40 }} />,
      path: "/people/faculty"
    },
    {
      title: "Students",
      description: "Our talented students who are the future leaders in technology and innovation.",
      icon: <PeopleIcon sx={{ fontSize: 40 }} />,
      path: "/people/students"
    },
    {
      title: "Alumni",
      description: "Our successful alumni who have made significant contributions in various fields.",
      icon: <Groups sx={{ fontSize: 40 }} />,
      path: "/people/alumni"
    }
  ];

  return (
    <Box sx={{ 
      py: { xs: 4, md: 8 },
      background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)',
      minHeight: '100vh'
    }}>
      <Container maxWidth="lg">
        <Typography variant="h3" align="center" gutterBottom sx={{ 
          mb: 8,
          color: 'primary.main',
          fontWeight: 800,
          fontSize: { xs: '2rem', md: '2.5rem' },
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: -16,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 80,
            height: 4,
            background: 'linear-gradient(90deg, #1a237e 0%, #c62828 100%)',
            borderRadius: 2
          }
        }}>
          Our People
        </Typography>

        <Grid container spacing={4}>
          {sections.map((section, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card sx={{ 
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                background: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                borderRadius: 4,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
                }
              }}>
                <CardContent sx={{ p: 4, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                  <Box sx={{ 
                    display: 'flex',
                    alignItems: 'center',
                    mb: 2,
                    color: 'primary.main'
                  }}>
                    {section.icon}
                    <Typography variant="h5" sx={{ ml: 2, fontWeight: 700 }}>
                      {section.title}
                    </Typography>
                  </Box>
                  
                  <Typography variant="body1" color="text.secondary" sx={{ mb: 3, flexGrow: 1 }}>
                    {section.description}
                  </Typography>

                  <Button
                    variant="contained"
                    onClick={() => navigate(section.path)}
                    sx={{
                      background: 'linear-gradient(45deg, #1a237e 30%, #c62828 90%)',
                      color: 'white',
                      '&:hover': {
                        background: 'linear-gradient(45deg, #000051 30%, #8e0000 90%)',
                      }
                    }}
                  >
                    Learn More
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default People; 